module.exports = __webpack_public_path__ + "static/media/airbnbLogo.c59720d6.png";